/*=============================================== IconMenuPage ===============================================*/

import { IconMenu } from "tsx-library-julseb"
import type { IconMenuItemProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, propAllLinksClickRequired, inputIcon } from "data"

const IconMenuPage = () => {
    const menuItems: IconMenuItemProps[] = [
        {
            icon: "edit",
            href: "/",
            label: "Button",
        },
        {
            icon: "check",
            to: "/",
            label: "Button",
        },
        {
            icon: "show",
            onClick: () => console.log("Clicked"),
            label: "Button",
        },
    ]

    const items: ItemType[] = [
        {
            content: (
                <IconMenu items={menuItems} direction="right" icon="plus" />
            ),
            code: 'const menuItems = [\n    {\n        icon: "edit",\n        href: "/",\n        label: "Button",\n    },\n    {\n        icon: "check",\n        to: "/",\n        label: "Button",\n    },\n    {\n        icon: "show",\n        onClick: () => console.log("Clicked"),\n        label: "Button",\n    },\n]\n\n<IconMenu items={menuItems} direction="right" icon="plus" />',
            codeTs: 'const menuItems: IconMenuItemProps[] = [\n    {\n        icon: "edit",\n        href: "/",\n        label: "Button",\n    },\n    {\n        icon: "check",\n        to: "/",\n        label: "Button",\n    },\n    {\n        icon: "show",\n        onClick: () => console.log("Clicked"),\n        label: "Button",\n    },\n]\n\n<IconMenu items={menuItems} direction="right" icon="plus" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "direction",
            type: "string",
            possible: ["left", "up", "right", "down"],
            default: "right",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        "separator",
        {
            subtitle: "items",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>item</code> object
                </>
            ),
            subtitle: "label",
            type: "string",
            required: true,
        },
        ...inputIcon(),
        ...propAllLinksClickRequired,
        "separator",
        {
            subtitle: "icon",
            type: "string or object",
            possible: ["plus", "burger", "object"],
            default: "burger",
        },
        {
            title: (
                <>
                    <code>icon</code> object
                </>
            ),
            subtitle: "open",
            type: "string",
            required: true,
        },
        {
            subtitle: "close",
            type: "string",
            required: true,
        },
        "separator",
        {
            subtitle: "openIconSize",
            intro: (
                <>
                    Only if <code>icon</code> is an <code>object</code>.
                </>
            ),
            type: "object",
        },
        {
            title: (
                <>
                    <code>openIconSize</code> object
                </>
            ),
            subtitle: "open",
            type: "number",
            default: "48 * 0.7",
        },
        {
            subtitle: "close",
            type: "number",
            default: "48 * 0.7",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default IconMenuPage
